<div
  [ngClass]="{
    'detail-sidebar-container': pageType === 'sidebar',
    'detail-modal-container': pageType === 'modal'
  }"
>
  <div (click)="back()" class="back-icon">
    <i
      *ngIf="backArrow && pageType === 'sidebar'"
      nz-icon
      nzType="left"
      nzTheme="outline"
    ></i>
  </div>

  <nz-tabset
    [(nzSelectedIndex)]="activatedIndex"
    [style.margin]="pageType === 'sidebar' ? '8px -24px' : '-24px -24px 0'"
    [nzTabBarStyle]="{
      'padding-left': pageType === 'sidebar' && backArrow ? '25px' : '9px'
    }"
    [class.side]="pageType === 'sidebar'"
  >
    <nz-tab [nzTitle]="basicInfo" (nzSelect)="checkTab(0)">
      <ng-template #basicInfo>{{ 'order.basic_info' | translate }}</ng-template>
      <div class="content">
        <host-house-order-basic
          [orderDetail]="orderDetail"
          [pageType]="pageType"
          [loading]="loading"
          (refreshModal)="refreshModal($event)"
          (changeOrder)="changeOrder($event)"
        ></host-house-order-basic>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="financeInfo" (nzSelect)="checkTab(1)">
      <ng-template #financeInfo>{{
        'order.income_and_expenses' | translate
      }}</ng-template>
      <div class="content">
        <host-house-order-finance
          [orderDetail]="orderDetail"
          [pageType]="pageType"
          (refreshModal)="refreshModal($event)"
        ></host-house-order-finance>
      </div>
    </nz-tab>
    <nz-tab [nzTitle]="personInfo" (nzSelect)="checkTab(2)">
      <ng-template #personInfo>{{ 'order.guest' | translate }}</ng-template>
      <ng-template nz-tab>
        <div class="content">
          <host-house-order-guest
            [code]="code"
            [pageType]="pageType"
            (refreshModal)="refreshModal($event)"
          ></host-house-order-guest>
        </div>
      </ng-template>
    </nz-tab>
  </nz-tabset>
</div>
